import { FC } from "react";

// MUI
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';

// Third party
import { Dayjs } from "dayjs";
import { Controller, useFormContext } from "react-hook-form";

type TRHFDateTimePickerProps = Omit<
  DatePickerProps<Dayjs>,
  "value" | "onChange" | "slotProps"
> & {
  name: string;
  slotProps?: DatePickerProps<Dayjs>["slotProps"];
};

const RHFDatePicker: FC<TRHFDateTimePickerProps>
  = ({
       name,
       label,
       slotProps,
       ...other
     }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          {...other}
          label={label}
          value={field.value as Dayjs | null}
          onChange={(newValue) => field.onChange(newValue)}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error?.message,
              ...(slotProps?.textField || {}),
            },
            ...slotProps,
          }}
        />
      )}
    />
  );
};

export { RHFDatePicker };